import React from 'react'

import { ApiContext } from '../../context/api/apiContext'

export const ReachForm = () => {
  const { jsonData } = useContext(ApiContext)
  const { reachForm: reachFormData } = jsonData.defaultSectionSettings

  return (
    <form className='reach_form'>
      {reachFormData.inputs.map(({ id, placeholder, type }, index) => {
        const isTextArea = type === 'textarea' ? true : false

        return (
          <div
            className={`reach_form_controller ${isTextArea ? 'full_mod' : ''}`}
            key={index}
          >
            <dl className='form_cell form_cell_v1_mod'>
              <dt className='form_cell_title form_v1_mod'>
                <label htmlFor={id} />
              </dt>
              <dd className='form_field_wrap form_v1_mod'>
                {isTextArea ? (
                  <textarea
                    className='form_field textarea_mod_1 default_mod'
                    id={id}
                    placeholder={placeholder}
                    defaultValue={''}
                  />
                ) : (
                  <input
                    className='form_field default_mod'
                    type='text'
                    id={id}
                    placeholder={placeholder}
                  />
                )}
              </dd>
            </dl>
          </div>
        )
      })}

      {/* <div className="reach_form_controller">
				<dl className="form_cell form_cell_v1_mod">
					<dt className="form_cell_title form_v1_mod">
						<label htmlFor="reach_last" />
					</dt>
					<dd className="form_field_wrap form_v1_mod">
						<input className="form_field default_mod" type="text" id="reach_last" placeholder="Last Name*" />
					</dd>
				</dl>
			</div>
			<div className="reach_form_controller">
				<dl className="form_cell form_cell_v1_mod">
					<dt className="form_cell_title form_v1_mod">
						<label htmlFor="reach_mail" />
					</dt>
					<dd className="form_field_wrap form_v1_mod">
						<input className="form_field default_mod" type="email" id="reach_mail" placeholder="Email*" />
					</dd>
				</dl>
			</div>
			<div className="reach_form_controller">
				<dl className="form_cell form_cell_v1_mod">
					<dt className="form_cell_title form_v1_mod">
						<label htmlFor="reach_link" />
					</dt>
					<dd className="form_field_wrap form_v1_mod">
						<input className="form_field default_mod" type="text" id="reach_link" placeholder="Link" />
					</dd>
				</dl>
			</div> */}
      {/* <div className="reach_form_controller full_mod">
				<dl className="form_cell form_cell_v1_mod">
					<dt className="form_cell_title form_v1_mod">
						<label htmlFor="reach_message" />
					</dt>
					<dd className="form_field_wrap form_v1_mod">
						<textarea className="form_field textarea_mod_1 default_mod" id="reach_message" placeholder="Message" defaultValue={""} />
					</dd>
				</dl>
			</div> */}
      <div className='reach_btn_wrap'>
        <button className='btn_v2'>{reachFormData.formButtonTitle}</button>
      </div>
    </form>
  )
}
export default ReachForm
